
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import PropTypes from 'prop-types';
import RenderAnimation from '@/src/components/RenderAnimation';
import RandomFactFileAnimatedIcon from '../../../../../animations/random_fact_file.json';
import s from './RandomFactFileButton.module.scss';
const propTypes = {
    isMobile: PropTypes.bool,
    selectRandomFactFile: PropTypes.func.isRequired
};
const RandomFactFileButton = ({ isMobile = false, selectRandomFactFile }) => {
    return (<div role="button" tabIndex={0} onClick={() => {
            selectRandomFactFile();
        }} onKeyDown={(e) => {
            if (e.key === 'Enter') {
                selectRandomFactFile();
            }
        }} className={[s.randomFactFileContainer, isMobile ? s.mobile : ''].join(' ')} data-testid={`${isMobile ? 'mobile-' : ''}random-fact-file-button`}>
      <div className={s.tester}>
        <div className={s.randomInnerContainerCopy}/>
      </div>
      <div className={s.randomInnerContainer}>
        <div className={s.randomDiamond}>
          <div className={s.randomAnimatedIcon}>
            <RenderAnimation ariaLabel="Random fact file icon" animation="random-fact-file" animationData={RandomFactFileAnimatedIcon} autoplay loop isStopped={false}/>
          </div>
        </div>
        <div className={s.randomTitle}>
          {isMobile ? ('Summon a random fact file') : (<>
              Summon a
              <br />
              random fact file
            </>)}
        </div>
      </div>
    </div>);
};
RandomFactFileButton.propTypes = propTypes;
export default RandomFactFileButton;

    async function __Next_Translate__getStaticProps__195ca0caf3f__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//FactFileIndex/components/FactFileFilterBar/RandomFactFileButton/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0caf3f__ as getStaticProps }
  